import { Container, Row, Col } from '@everlywell/leaves';
import SectionWrapper from 'components/SectionWrapper';
import {
  renderRichText,
  RenderRichTextData,
} from 'gatsby-source-contentful/rich-text';
import React from 'react';

import * as S from './styles';

interface Props {
  backgroundColor: string;
  slug: string;
  richText: RenderRichTextData<any>;
}

export const RichTextSection: React.FC<Props> = ({
  richText,
  slug,
  backgroundColor,
}: Props) => (
  <SectionWrapper
    data-testid={slug || 'richTextSection'}
    id={slug}
    backgroundColor={backgroundColor}
  >
    <Container>
      <Row>
        <Col xs>
          <S.Wrapper>{renderRichText(richText, {})}</S.Wrapper>
        </Col>
      </Row>
    </Container>
  </SectionWrapper>
);

export default RichTextSection;
